<template>
  <!-- 页脚 -->
  <footer class="site-footer">
    <!-- 顶部绿色分类栏 -->
    <div class="footer-categories">
      <div class="container">
        <div class="categories-bar">
          <span class="category-icon iconfont icon-guanlian"></span>
          <span class="category-label">相关链接</span>
          <a href="http://swcc.mwr.gov.cn/" class="category-link">水土保持司</a>
          <a href="http://www.swcc.org.cn/" class="category-link">水土保持生态建设网</a>
        </div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="footer-main">
      <div class="container">
        <div class="footer-content">
          <!-- 左侧logo和二维码 -->
          <div class="footer-left">
            <div class="footer-logo">
              <span class="logo1"><img src="@/assets/logo1.png" alt=""></span>
              <span class="logo2">Qintu Zhipei</span>
            </div>
            <div class="footermain">
              <!-- <div>主办单位：秦皇岛市数政局</div> -->
              <div>技术支持单位：秦皇岛市大数据有限公司</div>
              <div>建议您使用IE10 及以上版本、Chrome、360浏览器(极速模式)浏览器浏览本网站</div>
              <div class="footermain-item">域名备案号：<a href="https://beian.miit.gov.cn/" target="_blank" >冀ICP备2025101797号-4</a></div>
              <div class="footermain-item">冀公网安备：<a href="https://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" >13030202003994号</a></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>

<style scoped>
.site-footer {
  margin-top: 10px;
}

.footer-categories {
  background-color: #422C27;
  padding: 15px 0;
}

.categories-bar {
  display: flex;
  align-items: center;
  gap: 20px;
}

.category-icon {
  color: white;
  font-size: 25px;
  margin-right: -14px;
}

.category-label {
  color: white;
  font-size: 14px;
  font-weight: 500;
}

.category-link {
  color: white;
  text-decoration: none;
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.category-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.footer-main {
  background-color: #4a4a4a;
  padding: 20px 0;
}

.footer-content {
  display: flex;
  gap: 60px;
  align-items: flex-start;
}

.footer-left {
  display: flex;
  flex-shrink: 0;
}

.footermain {
  margin-left: 280px;
  font-size: 14px;
  color: #fff;
}

.footermain div {
  margin-bottom: 10px;
}

.footer-logo {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}

.footer-logo .logo1 img {
  width: 120px;
}

.footer-logo .logo2 {
  padding-top: 10px;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.footer-logo .logo2 img {
  width: 30px;
  margin-top: 10px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.footermain-item a{
  color: #1890ff;
  text-decoration: underline;
}
</style>